import { ReactElement } from 'react';

import { Loader } from '@calm-web/design-system';

import ProgramInfo from '@/components/app/programV2/ProgramInfo';
import UpsellBanner from '@/components/UpsellBanner';
import { useIsRouting } from '@/hooks/utils/useIsRouting';

const ProgramLayout = (): ReactElement => {
	const isRouting = useIsRouting();

	return (
		<>
			<UpsellBanner />
			{isRouting ? <Loader /> : <ProgramInfo />}
		</>
	);
};

export default ProgramLayout;
